module.exports = __webpack_public_path__ + "static/media/timeline-inativo.159526a7.svg";